import React, { useEffect, useState } from 'react'
import SideBar from '../Sidebar/SideBar';
import ClientsGroup from '../../Api/ClientGroup'
import { Icon } from '@iconify/react/dist/iconify.js';
import Branches from '../../Api/Branches';
import Swal from "sweetalert2";
const ClientGroup = () => {

    const [name, setName] = useState();
    const [groupId, setGroupId] = useState();

    const [data1, setData1] = useState([]);

    const handleEdit = (item) => {
        setGroupId(item.id)
        setName(item.name)
        console.log(`Edit item with id ${item.id}`);
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Delete this group?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete",
            cancelButtonText: "No, keep it",
            reverseButtons: true,
            width: "340px",
        });

        if (!result.isConfirmed) return;

        const response = await ClientsGroup.DeleteClientGroupById(id)

        if (response?.StatusCode === 200) {
            Swal.fire({ title: "Deleted", text: "Deleted Successfully", icon: "success", width: "320px" })
            fetchData()
        }
    };

    useEffect(() => {
        console.log("name", name);
    }, [name]);


    /**********************************************************/

    const handleSave = async () => {
        if (!name || name.trim() === "") {
            Swal.fire({ title: "Name required", text: "Please enter a group name.", icon: "warning", width: "320px" });
            return;
        }

        const response = await ClientsGroup.CreateClientGroup(name.trim())
        if (response?.StatusCode == 200 || response?.StatusCode == 201) {
            Swal.fire({ title: "Saved", text: "Group created successfully", icon: "success", width: "320px" });

            // immediately show in list (optimistic), fall back to name if API doesn't return item
            const createdItem = response?.Result || response?.result || response;
            const newItem = {
                id: createdItem?.id ?? `temp-${Date.now()}`,
                name: createdItem?.name ?? name.trim(),
            };
            setData1(prev => [...prev, newItem]);

            setName('');
            setTransferredItems([]);
            setFilteredData([]);
            await fetchData();
        }
    }

    /**********************************************************/

    // { id: 1, sno: '1', name: 'Optical Branch 1' },
    // { id: 2, sno: '2', name: 'Restaurant Branch 1' },
    // { id: 3, sno: '3', name: 'Optical Branch 2' },
    // { id: 4, sno: '4', name: 'Restaurant Branch 2' },
    const [data, setData] = useState([]);

    const [searchQuery, setSearchQuery] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [transferredItems, setTransferredItems] = useState([]);

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    useEffect(() => {
        console.log("transferredItems", transferredItems);
    }, [transferredItems]);

    const handleSearchClick = () => {
        const results = data.filter(item =>
            item.branchName.toLowerCase().includes(searchQuery.toLowerCase())
        );

        setFilteredData(prevFilteredData => {
            const newFilteredData = [...prevFilteredData];
            results.forEach(item => {
                if (!newFilteredData.some(existingItem => existingItem.id === item.id)) {
                    newFilteredData.push(item);
                }
            });
            return newFilteredData;
        });
    };

    const handleRowClick = (item) => {
        setFilteredData(prevFilteredData =>
            prevFilteredData.filter(existingItem => existingItem.id !== item.id)
        );

        setTransferredItems(prevTransferredItems => [
            ...prevTransferredItems,
            item
        ]);
    };

    const handleDeleteTab = (id) => {
        setTransferredItems(prevTransferredItems =>
            prevTransferredItems.filter(item => item.id !== id)
        );
    };

    const getSerialNumber = (index) => index + 1;


    const fetchData = async () => {
        const response = await ClientsGroup.GetClientGroups()
        if (response) {
            console.log("response", response);
            setData1(response.Result)
        }
    }

    useEffect(() => {
        fetchData()
        fetchBranches()
    }, []);


    const fetchBranches = async () => {
        const response = await Branches.GetAllClients()
        if (response) {
            console.log("response", response);
            setData(response.Result)
        }
    }

    const handleUpdate = async () => {
        if (!groupId) return;
        if (!name || name.trim() === "") {
            Swal.fire({ title: "Name required", text: "Please enter a group name.", icon: "warning", width: "320px" });
            return;
        }

        // update group name
        const updateResp = await ClientsGroup.UpdateClientGroupById(groupId, name.trim());

        // attach selected branches (if any)
        if (transferredItems.length > 0) {
            const dataToSend = transferredItems.map(branch => ({
                branchId: branch.id,
                groupId: groupId
            }));

            await Promise.all(dataToSend.map(data => ClientsGroup.AddBranchToGroup(data)));
        }

        if (updateResp?.StatusCode === 200) {
            // immediately reflect in UI
            setData1(prev => prev.map(item => item.id === groupId ? { ...item, name: name.trim() } : item));

            Swal.fire({ title: "Updated", text: "Group updated successfully", icon: "success", width: "320px" });
            await fetchData();
        }

        // reset state after update
        setGroupId(undefined);
        setName('');
        setTransferredItems([]);
        setFilteredData([]);
    }

    return (
        <div className='Flex-general-client-sidebar'>
            <div className='sidebar-gen-width'>
                <SideBar />
            </div>
            <div className='Main-general-Client'>
                <div className='header-general'>
                    <h2 className='general-card-title'>Client Group</h2>
                </div>
                <div className="control_radius">
                    <div className="company_control">
                        {/* <div className="stock-im-dep1">
                            <div className="input-box-Imo1">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" required />
                                    <label class="modify_p_text2">Id</label>
                                </div>
                            </div>
                        </div> */}
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="name" value={name} onChange={(e) => setName(e.target.value)} required />
                                    <label class="modify_p_text2">Group Name</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1 flex-search-btn">
                                    <input
                                        type="text"
                                        className="modify_im_input mode_category1"
                                        placeholder="Search..."
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                    <button className="search-button-main" onClick={handleSearchClick}>Search</button>
                                    <label className="modify_lbl_text3">Search</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="">
                        <div className="company_control">
                            <div className="stock-im-dep1"></div>
                            <div className="table-search-menu" style={{ height: "auto", overflowY: "scroll", maxHeight: "500px" }}>
                                <table className="data-table">
                                    <thead className='header-table-search'>
                                        <tr>
                                            <th className='table-header-manager ac-sno-wth'>SNo</th>
                                            {/* <th className='table-header-manager'>ID</th> */}
                                            <th className='table-header-manager'>Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.length > 0 ? (
                                            filteredData.map((item, index) => (
                                                <tr
                                                    key={item.id}
                                                    onClick={() => handleRowClick(item)}
                                                >
                                                    <td className='table-data-account ac-sno-wth first-tab-padd'>{getSerialNumber(index)}</td>
                                                    {/* <td className='table-data-account first-tab-padd'>{item.id}</td> */}
                                                    <td className='table-data-account first-tab-padd'>{item.branchName}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3">No results found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {transferredItems.length > 0 && (
                                <div className="table-search-menu">
                                    <table className="data-table">
                                        <thead className='header-table-search'>
                                            <tr>
                                                <th className='table-header-manager'>SNo</th>
                                                <th className='table-header-manager'>ID</th>
                                                <th className='table-header-manager'>Name</th>
                                                <th className='table-header-manager'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {transferredItems.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td className='table-data-account bg-other-table'>{getSerialNumber(index)}</td>
                                                    <td className='table-data-account bg-other-table'>{item.id}</td>
                                                    <td className='table-data-account bg-other-table'>{item.branchName}</td>
                                                    <td className='table-data-account bg-other-table'>
                                                        <button className="delete-btn-acc" onClick={() => handleDeleteTab(item.id)}>
                                                            <Icon icon="material-symbols:delete" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="ButtonTabSave">


                        {
                            groupId ? (
                                <button
                                    id="SaveBtnMain"
                                    className={`update-button-main-save hovered`}
                                    onClick={handleUpdate}
                                >
                                    Update
                                </button>

                            ) : (
                                <button
                                    id="SaveBtnMain"
                                    className={`save-button-main-save hovered`}
                                    onClick={handleSave}
                                >
                                    Save
                                </button>
                            )
                        }
                    </div>
                </div>
                <div className="company_info-text-im depart_top">Client Group List</div>
                <div className="control_radius">
                    <div className="table-account-manager">
                        <table className='table-master-acc'>
                            <thead className='header-table-account'>
                                <tr>
                                    <th className='table-header-manager ac-sno-wth'>S.No</th>
                                    {/* <th className='table-header-manager'>Id</th> */}
                                    <th className='table-header-manager'>Group Name</th>
                                    {/* <th className='table-header-manager'>Branch List</th> */}
                                    <th className='table-header-manager'>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data1.map((item, idx) => (
                                    <tr key={item.id}>
                                        <td className='table-data-account ac-sno-wth'>{idx + 1}</td>
                                        {/* <td className='table-data-account'>{item.id}</td> */}
                                        <td className='table-data-account'>{item.name}</td>
                                        {/* <td className='table-data-account'>{item.type}</td> */}
                                        <td className='table-data-account'>
                                            <button className="edit-btn-acc" onClick={() => handleEdit(item)}><Icon icon="lucide:edit" /></button>
                                            <button className="delete-btn-acc" onClick={() => handleDelete(item.id)}><Icon icon="material-symbols:delete" /></button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ClientGroup;
